import { Signal } from '@angular/core';

export interface AuthUser {
  id: string;
  name: string;
  email: string | null;
  tenant: string | null;
}

export abstract class AuthService {
  abstract readonly isAuthenticated: Signal<boolean>;
  abstract readonly user: Signal<AuthUser | null>;
  abstract logout(): Promise<void>;
}
